import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { useNavigate } from 'react-router-dom'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { useForm, Controller } from 'react-hook-form'
import { Circles } from 'react-loader-spinner'
import { Form } from 'react-bootstrap'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import 'react-toastify/dist/ReactToastify.css'
import './modalLogin.scss'
import { getVehicleDetailsList, userSingIn, userSingUp } from '../../redux/actions/login'
import URL from '../../constants/urls'
import getConfigDetails from '../../services/config'
import { restrictInValidCharPassword, validatePassword } from '../../utils/helper'


function ModalLogin(props) {
    const { setShow, show, loaderSing, dispatch, notify, useFor, partnerDetails } = props
    const { register, handleSubmit, formState: { errors }, control, reset, setValue, getValues } = useForm()
    const handleClose = () => {
        setShow(false)
        setModalSignup(0)
    }
    const navigate = useNavigate()
    const partner = window.location.toString().split('/')[3]
    const [modalSingup, setModalSignup] = useState(0)
    const [passwordShown, setPasswordShown] = useState(false)
    const [cpasswordShown, setCPasswordShown] = useState(false)
    const [mpasswordShown, setMPasswordShown] = useState(false)
    const [vehicleData, setVehicleData] = useState(EMPTY_ARRAY)
    const [stateData, setStateData] = useState(EMPTY_ARRAY)
    const [error, setError] = useState({ password_strength: false, confirm_password_strength: false })

    useEffect(() => {
        setModalSignup(useFor ? Number(useFor) : 0)
    }, [useFor])

    useEffect(() => {
        if (partnerDetails?.id) {
            handleCountryStateRequest()
        }
    }, [EMPTY_ARRAY, partnerDetails])

    const handleCountryStateRequest = (id) => {
        dispatch(getVehicleDetailsList(id)).then((res) => {
            setVehicleData(res)
            setStateData(res?.state)
        })
    }
    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') {
            setPasswordShown(passwordShown ? false : true)
        }
        if (key === 'mpassword') {
            setMPasswordShown(mpasswordShown ? false : true)
        }
        if (key === 'cpassword') {
            setCPasswordShown(cpasswordShown ? false : true)
        }
    }

    const handleInputChange = (e) => {
        let formValue = getValues()?.[e.target.name]
        setValue(e.target.name, restrictInValidCharPassword(formValue))
        const { name } = e.target
        if (name == 'password') {
            setError({ ...error, password_strength: false })
        } else {
            setError({ ...error, confirm_password_strength: false })
        }
    }

    const handleSecondModal = () => {
        reset(formValues => ({
            ...formValues,
            username: '',
            password: '',
            country: 'US'
        }))
        handleCountryStateRequest()
        setModalSignup(1)
    }

    const onSignIn = (data) => {
        if (data?.username !== '' && data?.password !== '') {
            const payloadKeys = { 'client_id': getConfigDetails?.CLIENT_ID, 'client_secret': getConfigDetails?.CLIENT_SECRET, 'grant_type': 'password' }
            const finalPayload = { ...payloadKeys, ...data }
            dispatch(userSingIn(finalPayload)).then((res) => {
                if (res?.status === 201 && res?.data !== null) {
                    localStorage?.setItem('userData', JSON.stringify(res?.data))
                    localStorage?.setItem('access_token', JSON.stringify(res?.data?.access_token))
                    notify('success', 'User Login Successfully')
                    setShow(false)
                    reset(formValues => ({ ...formValues, 'username': '', 'password': '' }))
                    navigate(0)
                } else {
                    notify('error', res?.errors?.message)
                }
            }).catch((errors) => {
                notify('error', errors?.message)
            })
        }
    }

    const onSignUp = (data) => {
        if (!validatePassword(data?.password)) {
            setError({ ...error, password_strength: true })
            return
        } else if (!validatePassword(data?.cpassword)) {
            setError({ ...error, confirm_password_strength: true })
            return
        }
        if (data?.cpassword === data?.password) {
            const payload = {
                'first_name': '',
                'last_name': '',
                'email': '',
                'phone': '',
                'confirm_password': '',
                'client_secret': getConfigDetails?.CLIENT_SECRET,
                'base_url': `${getConfigDetails?.baseURL}/${partner}`
            }
            const finalPayload = { ...payload, ...data }
            finalPayload['confirm_password'] = finalPayload?.cpassword
            delete finalPayload?.password
            delete finalPayload?.cpassword
            delete finalPayload?.username

            dispatch(userSingUp(finalPayload)).then((res) => {
                if (res?.status === 201) {
                    localStorage?.setItem('userData', JSON.stringify(res?.data))
                    localStorage?.setItem('access_token', JSON.stringify(res?.data?.access_token))
                    notify('success', 'Registration Successfully Completed')
                    const payloadKeys = { 'client_id': getConfigDetails?.CLIENT_ID, 'client_secret': getConfigDetails?.CLIENT_SECRET, 'grant_type': 'password' }

                    payloadKeys.username = data?.email
                    payloadKeys.password = data?.password
                    dispatch(userSingIn(payloadKeys)).then((res) => {
                        const userData = res?.data
                        if (userData) {
                            localStorage.setItem('userData', JSON.stringify(userData))
                            localStorage?.setItem('access_token', JSON.stringify(userData?.access_token))
                            navigate(0)
                        } else {
                            notify(res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                        }
                    }).catch((err) => {
                        const response = err?.errors
                        notify(response?.message ? response?.message : 'Something went wrong, Please try again!')
                    })
                    setShow(false)
                    reset(formValues => ({
                        ...formValues,
                        'first_name': '',
                        'last_name': '',
                        'email': '',
                        'phone': '',
                        'confirm_password': '',
                        'client_secret': getConfigDetails?.CLIENT_SECRET
                    }))
                } else {
                    notify('error', res?.errors?.message)
                }
            }).catch(() => {
                notify('error', 'Something went wrong!')
            })
        } else {
            notify('error', 'Password not match')
        }
    }

    const handleBackButton = () => {
        reset(formValues => ({
            ...formValues,
            email: '',
            phone: '',
            first_name: '',
            cpassword: '',
            password: '',
            country: 'US'
        }))
        handleCountryStateRequest()
        setModalSignup(0)
    }

    const handleForgotPassword = () => {
        navigate(`/${partner}${URL?.BASE_SEND_EMAIL_FORGOT_PASSWORD}`)
        setShow(false)
    }

    const handleCountryState = (e) => {
        const { value } = e.target
        if (value !== '') {
            const selectedId = (vehicleData?.country?.find(country => country?.country_code == value) || {})?.id
            handleCountryStateRequest(selectedId)
        }
    }

    return (
        <>
            <Modal show={show} size={modalSingup === 1 ? 'lg' : null} onHide={handleClose}>
                {modalSingup === 0 &&
                    <form onSubmit={handleSubmit(onSignIn)}>
                        <Modal.Header closeButton> <Modal.Title>Login</Modal.Title> </Modal.Header>
                        <Modal.Body>
                            <div className="mb-3">
                                <label htmlFor="exampleInputEmail1" className="form-label">User Name <span style={{ color: 'red' }}>*</span></label>
                                <input type="email" name='username' className="form-control" maxLength='40' minLength='1' placeholder="" {...register('username', {
                                    required: true,
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'invalid email address'
                                    }
                                })} />
                                {errors?.username?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                {errors?.username?.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.username?.message}</span>}
                            </div>

                            <div className="mb-3 myiconset">
                                <label htmlFor="exampleInputPassword1" className="form-label">Password <span style={{ color: 'red' }}>*</span>
                                    <span className="popoverSection position-relative"  >
                                        <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                        <i
                                            className="fa fa-question-circle "
                                        >
                                        </i>
                                    </span>
                                </label>
                                <input type={passwordShown ? 'text' : 'password'} name='password' className="form-control passwordInput" id="exampleInputPassword1"   {...register('password', { required: true })}
                                    minLength={8}
                                    maxLength={15} />
                                <i className={passwordShown ? 'fas fa-eye-slash loginPassIcon' : 'fas fa-eye loginPassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
                                {errors?.password?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                            </div>
                            <div className='mb-3 cursor' >
                                <span className="form-label" onClick={() => { handleForgotPassword() }}>Forgot Password? </span>
                            </div>

                            <div className="mb-3">
                                <Button variant="primary" type='submit' className="btn text-white bg-primary btn-lg w-100" onClick={handleSubmit} disabled={(loaderSing)}>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <span>Sign in </span>  <span className='ms-2'>
                                            {(loaderSing) ? <Circles
                                                height="20"
                                                width="20"
                                                style={{ display: 'inline-block' }}
                                                color="#ffffff"
                                                ariaLabel="circles-loading"
                                                visible={true}
                                            /> : null}
                                        </span>
                                    </div>
                                </Button>
                            </div>
                            <div className="mb-3 text-center">
                                New on our platform? <a type='button' className='text-primary' role='button' onClick={handleSecondModal}>Create an account</a>
                            </div>
                        </Modal.Body>
                    </form>
                }
                {modalSingup === 1 &&
                    <form onSubmit={handleSubmit(onSignUp)}>
                        <Modal.Header closeButton> <Modal.Title>Register your Account</Modal.Title></Modal.Header>
                        <Modal.Body style={{
                            maxHeight: 'calc(100vh - 210px)',
                            overflowY: 'auto'
                        }} >
                            <div className="checkinForm">
                                <h6 className='text-muted fw-semibold'>Login Info</h6>
                                <div className='row'>
                                    <div className='col'>
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Email <span style={{ color: 'red' }}>*</span></label>
                                            <input type="email" name='email' className="form-control" maxLength='40' minLength='1' placeholder="Enter your email" {...register('email', {
                                                required: true,
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: 'invalid email address'
                                                }
                                            })} />
                                        </div>
                                        {errors?.email?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        {errors?.email?.type === 'pattern' && <span className="text-danger small">{errors?.email?.message}</span>}
                                    </div>
                                    <div className='col'>
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Phone <span style={{ color: 'red' }}>*</span></label>
                                            <Controller
                                                name="phone"
                                                type="text"
                                                id="phone"
                                                control={control}
                                                rules={{
                                                    required: true,
                                                    minLength: {
                                                        value: 10,
                                                        message: 'Minimum 10 characters allowed',
                                                    },
                                                    maxLength: {
                                                        value: 10,
                                                        message: 'Maximum 10 characters allowed',
                                                    },
                                                }}
                                                render={({ field }) => <MaskedInput
                                                    maskGenerator={phoneMaskGenerator}
                                                    className="form-control"
                                                    {...field}
                                                    maxLength={14}
                                                    title="Please enter a valid phone number"
                                                    onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                                    onInput={e => e.target.setCustomValidity('')}
                                                    placeholder="Phone Number"
                                                />}
                                            />
                                        </div>
                                        {errors?.phone?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        {errors?.phone?.type === 'minLength' && <span className="text-danger small">{errors?.phone?.message}</span>}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6 myiconset">
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Password <span style={{ color: 'red' }}>*</span>
                                                <span className="popoverSection position-relative"  >
                                                    <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                                    <i
                                                        className="fa fa-question-circle "
                                                    >
                                                    </i>
                                                </span></label>
                                            <input className="form-control  passwordInput"
                                                name="password" placeholder="Create Password"
                                                {...register('password', {
                                                    required: true,
                                                    onChange: (e) => handleInputChange(e)
                                                })}
                                                type={mpasswordShown ? 'text' : 'password'} />
                                        </div>
                                        <i className={mpasswordShown ? 'fas fa-eye-slash iconset' : 'fas fa-eye iconset'} onClick={(e) => togglePasswordVisiblity(e, 'mpassword')}></i>
                                        {errors?.password?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        {(error?.password_strength) && <Form.Text className="text-danger">Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).</Form.Text>}
                                    </div>
                                    <div className="col-sm-6 myiconset">
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Confirm Password <span className="text-danger small">*</span>
                                                <span className="popoverSection position-relative"  >
                                                    <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-). </div>
                                                    <i
                                                        className="fa fa-question-circle "
                                                    >
                                                    </i>
                                                </span>
                                            </label>
                                            <input className="form-control  passwordInput"
                                                {...register('cpassword', {
                                                    required: true,
                                                    onChange: (e) => handleInputChange(e)
                                                })}
                                                name="cpassword" placeholder="Confirm Password"
                                                type={cpasswordShown ? 'text' : 'password'} />
                                        </div>
                                        <i className={cpasswordShown ? 'fas fa-eye-slash iconset' : 'fas fa-eye iconset'} onClick={(e) => togglePasswordVisiblity(e, 'cpassword')}></i>
                                        {errors?.cpassword?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        {(error?.confirm_password_strength) && <Form.Text className="text-danger small">Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).</Form.Text>}
                                    </div>
                                </div>
                                <hr />
                                <h6 className='text-muted fw-semibold'>Contact Info</h6>
                                <div className='row row-cols-sm-2 row-cols-1'>
                                    <div className='col'>
                                        <div className="mb-2">
                                            <label htmlFor="" className="form-label">First Name <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" className="form-control" name='first_name' id="first_name" placeholder="Enter First Name" {...register('first_name', { required: true })} />
                                            {errors?.first_name?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className="mb-2">
                                            <label htmlFor="" className="form-label">Last Name <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" name='last_name' className="form-control" id="last_name" placeholder="Enter Last Name" {...register('last_name', { required: true })} />
                                            {errors?.last_name?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Company Name</label>
                                            <input type="text" name='company_name' className="form-control" id="company_name" placeholder="Enter Company Name" {...register('company_name')} />
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Address 1 <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" name='address1' className="form-control" id="address1" placeholder="Enter Address 1" {...register('address1', { required: true })} />
                                            {errors?.address1?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Address 2</label>
                                            <input type="text" name='address2' className="form-control" id="address2" placeholder="Enter Address 2" {...register('address2')} />
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">City <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" name='city' className="form-control" id="city" placeholder="Enter City" {...register('city', { required: true })} />
                                            {errors?.city?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Country <span style={{ color: 'red' }}>*</span></label>
                                            <Controller
                                                name="country"
                                                id='country'
                                                control={control}
                                                defaultValue={getValues().country}
                                                className='form-select'
                                                rules={{ required: true }}
                                                render={({ field }) => <select type="select" className='form-select' name='country' id='country' {...field} onChange={(e) => { field.onChange(e); handleCountryState(e) }}>
                                                    <option value=''>Select Country</option>
                                                    {vehicleData?.country?.map((item, index) => <option key={(index + 1)} value={item?.country_code} >{item?.name}</option>)}
                                                </select>}
                                            />
                                            {errors?.country?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">State <span style={{ color: 'red' }}>*</span></label>
                                            <Controller
                                                name="state"
                                                id='state'
                                                control={control}
                                                defaultValue=""
                                                className='form-select'
                                                rules={{ required: true }}
                                                render={({ field }) => <select className='form-select' name="state" id='state' {...field}>
                                                    <option value=''>Select an option</option>
                                                    {stateData?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.state_code}</option>)}
                                                </select>}
                                            />
                                            {errors?.state?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                        </div>
                                    </div>

                                    <div className='col'>
                                        <div className='mb-2'>
                                            <label htmlFor="" className="form-label">Zip / Postal Code <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" name='zipcode' minLength='5' maxLength='6' className="form-control" id="zipcode" placeholder="Enter pincode"
                                                {...register('zipcode', { required: true, minLength: 5, maxLength: 6 })}
                                            />
                                            {errors?.zipcode?.type === 'required' && <span className="text-danger small">This field is required</span>}
                                            {errors?.zipcode?.type === 'minLength' && <span className="text-danger small">Please enter a valid pincode</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-outline-secondary me-auto" type='button' onClick={handleBackButton} ><i className="fa fa-angle-left"></i> Back To Login</button>
                            <Button type="submit" className="btn text-white bg-primary">
                                <div className='d-flex aling-items-center'>
                                    <span>Submit</span> <span className='ms-2'>
                                        {loaderSing ? <Circles
                                            height="20"
                                            width="20"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /> : null}
                                    </span>
                                </div>
                            </Button>
                        </Modal.Footer>
                    </form>
                }
            </Modal>
            {/* <ToastContainer /> */}
        </>
    )
}
ModalLogin.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    setShow: PropTypes.func,
    show: PropTypes.bool,
    loaderSing: PropTypes.bool,
    notify: PropTypes.func,
    useFor: PropTypes.number,
    partnerDetails: PropTypes.object,
}

ModalLogin.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    setShow: noop,
    show: false,
    loaderSing: false,
    notify: noop,
    useFor: '0',
    partnerDetails: EMPTY_OBJECT,

}

function mapStateToProps({ loginReducer }) {
    return {
        loaderSing: loginReducer?.loader
    }
}
export default connect(mapStateToProps)(ModalLogin)